import URLBuilder from '@/lib/url-builder';

export default function contentContactsUrl(
  urlQuerySearchParams?: URLSearchParams | null | undefined,
  urlHash?: string | null | undefined,
): string {
  const url = new URLBuilder(`/kontakty`, urlQuerySearchParams, urlHash);
  return url.build();
}
